import { Drawing } from "../lib/drawing";

// prettier-ignore
export const watch = new Drawing({
  pixels: {
    // Hour hand
    462: true, 463: true, 464: true,
    // Minute hand
    368: true, 400: true, 432: true,
    // Googley eyes
    397: true, 434: true,
    // Crown
    437: true, 469: true,
    // Left face
    332: true, 363: true, 395: true, 427: true, 459: true, 491: true, 523: true,
    556: true,
    // Right face
    339: true, 372: true, 404: true, 436: true, 468: true, 500: true, 532: true,
    563: true,
    // Top strap
    205: true, 206: true, 207: true, 208: true, 209: true, 210: true, 237: true,
    238: true, 239: true, 240: true, 241: true, 242: true, 269: true, 270: true,
    271: true, 272: true, 273: true, 274: true, 301: true, 302: true, 303: true,
    304: true, 305: true, 306: true,
    // Bottom strap
    589: true, 590: true, 591: true, 592: true, 593: true, 594: true, 621: true,
    622: true, 623: true, 624: true, 625: true, 626: true, 653: true, 654: true,
    655: true, 656: true, 657: true, 658: true, 685: true, 686: true, 687: true,
    688: true, 689: true, 690: true,
  }
});

// prettier-ignore
export const cheers = new Drawing({
  pixels: {
    70: true, 71: true, 72: true, 73: true, 74: true, 102: true, 107: true,
    108: true, 109: true, 110: true, 111: true, 134: true, 143: true, 166: true,
    167: true, 174: true, 197: true, 199: true, 200: true, 201: true, 202: true,
    203: true, 204: true, 205: true, 206: true, 229: true, 231: true, 232: true,
    233: true, 234: true, 235: true, 236: true, 237: true, 261: true, 263: true,
    264: true, 265: true, 266: true, 267: true, 268: true, 281: true, 282: true,
    292: true, 295: true, 296: true, 297: true, 298: true, 299: true, 301: true,
    309: true, 310: true, 311: true, 312: true, 314: true, 323: true, 329: true,
    333: true, 338: true, 339: true, 340: true, 346: true, 354: true, 359: true,
    362: true, 363: true, 364: true, 370: true, 378: true, 386: true, 392: true,
    393: true, 396: true, 403: true, 404: true, 405: true, 406: true, 407: true,
    408: true, 409: true, 418: true, 423: true, 427: true, 436: true, 437: true,
    438: true, 439: true, 440: true, 441: true, 449: true, 456: true, 457: true,
    458: true, 470: true, 471: true, 472: true, 473: true, 474: true, 480: true,
    487: true, 490: true, 501: true, 503: true, 504: true, 507: true, 516: true,
    517: true, 518: true, 519: true, 520: true, 521: true, 534: true, 535: true,
    536: true, 537: true, 538: true, 540: true, 549: true, 550: true, 551: true,
    552: true, 553: true, 554: true, 566: true, 567: true, 571: true, 573: true,
    580: true, 591: true, 592: true, 593: true, 594: true, 595: true, 596: true,
    598: true, 600: true, 601: true, 604: true, 606: true, 611: true, 620: true,
    621: true, 622: true, 628: true, 631: true, 633: true, 638: true, 639: true,
    642: true, 651: true, 660: true, 664: true, 665: true, 666: true, 673: true,
    683: true, 692: true, 697: true, 698: true, 699: true, 704: true, 716: true,
    717: true, 718: true, 719: true, 720: true, 721: true, 722: true, 723: true,
    728: true, 729: true, 732: true, 733: true, 749: true, 750: true, 751: true,
    752: true, 753: true, 754: true, 755: true, 766: true, 767: true, 782: true,
    783: true, 784: true, 785: true, 786: true, 799: true, 816: true, 817: true,
    819: true, 847: true, 849: true, 852: true, 853: true, 879: true, 881: true,
    882: true, 884: true, 886: true, 912: true, 913: true, 914: true, 917: true,
    919: true, 944: true, 946: true, 950: true, 951: true, 976: true, 977: true,
    978: true, 983: true, 1009: true, 1010: true, 1015: true,
  },
});

// prettier-ignore
export const abstract = new Drawing({
  pixels: {
    0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true,
    8: true, 9: true, 10: true, 11: true, 12: true, 13: true, 14: true,
    15: true, 16: true, 17: true, 18: true, 19: true, 32: true, 33: true,
    34: true, 35: true, 36: true, 37: true, 38: true, 39: true, 40: true,
    41: true, 42: true, 43: true, 44: true, 45: true, 46: true, 47: true,
    52: true, 53: true, 54: true, 55: true, 64: true, 65: true, 66: true,
    67: true, 68: true, 69: true, 70: true, 71: true, 72: true, 73: true,
    74: true, 75: true, 76: true, 84: true, 85: true, 86: true, 87: true,
    88: true, 89: true, 90: true, 96: true, 97: true, 98: true, 99: true,
    100: true, 101: true, 102: true, 103: true, 104: true, 105: true, 106: true,
    116: true, 117: true, 118: true, 119: true, 120: true, 121: true, 122: true,
    123: true, 124: true, 128: true, 129: true, 130: true, 131: true, 132: true,
    133: true, 134: true, 135: true, 136: true, 148: true, 149: true, 150: true,
    151: true, 152: true, 153: true, 154: true, 155: true, 156: true, 157: true,
    160: true, 161: true, 162: true, 163: true, 164: true, 165: true, 166: true,
    167: true, 180: true, 181: true, 182: true, 183: true, 184: true, 185: true,
    186: true, 187: true, 188: true, 189: true, 190: true, 192: true, 193: true,
    194: true, 195: true, 196: true, 197: true, 198: true, 212: true, 213: true,
    214: true, 215: true, 216: true, 217: true, 218: true, 219: true, 220: true,
    221: true, 222: true, 223: true, 224: true, 225: true, 226: true, 227: true,
    228: true, 229: true, 244: true, 245: true, 246: true, 247: true, 248: true,
    249: true, 250: true, 251: true, 252: true, 253: true, 254: true, 255: true,
    256: true, 257: true, 258: true, 259: true, 260: true, 276: true, 277: true,
    278: true, 279: true, 280: true, 281: true, 282: true, 283: true, 284: true,
    285: true, 286: true, 287: true, 288: true, 289: true, 290: true, 291: true,
    308: true, 309: true, 310: true, 311: true, 312: true, 313: true, 314: true,
    315: true, 316: true, 317: true, 318: true, 319: true, 320: true, 321: true,
    322: true, 323: true, 340: true, 341: true, 342: true, 343: true, 344: true,
    345: true, 346: true, 347: true, 348: true, 349: true, 350: true, 351: true,
    352: true, 353: true, 354: true, 372: true, 373: true, 374: true, 375: true,
    376: true, 377: true, 378: true, 379: true, 380: true, 381: true, 382: true,
    383: true, 384: true, 385: true, 386: true, 404: true, 405: true, 406: true,
    407: true, 408: true, 409: true, 410: true, 411: true, 412: true, 413: true,
    414: true, 415: true, 416: true, 417: true, 436: true, 437: true, 438: true,
    439: true, 440: true, 441: true, 442: true, 443: true, 444: true, 445: true,
    446: true, 447: true, 448: true, 449: true, 468: true, 469: true, 470: true,
    471: true, 472: true, 473: true, 474: true, 475: true, 476: true, 477: true,
    478: true, 479: true, 480: true, 481: true, 500: true, 501: true, 502: true,
    503: true, 504: true, 505: true, 506: true, 507: true, 508: true, 509: true,
    510: true, 511: true, 512: true, 532: true, 533: true, 534: true, 535: true,
    536: true, 537: true, 538: true, 539: true, 540: true, 541: true, 542: true,
    543: true, 544: true, 564: true, 565: true, 566: true, 567: true, 568: true,
    569: true, 570: true, 571: true, 572: true, 573: true, 574: true, 575: true,
    576: true, 596: true, 597: true, 598: true, 599: true, 600: true, 601: true,
    602: true, 603: true, 604: true, 605: true, 606: true, 607: true, 608: true,
    628: true, 629: true, 630: true, 631: true, 632: true, 633: true, 634: true,
    635: true, 636: true, 637: true, 638: true, 639: true, 640: true, 641: true,
    642: true, 643: true, 644: true, 645: true, 646: true, 647: true, 648: true,
    649: true, 650: true, 651: true, 652: true, 653: true, 654: true, 655: true,
    656: true, 657: true, 658: true, 659: true, 672: true, 673: true, 674: true,
    675: true, 676: true, 677: true, 678: true, 679: true, 680: true, 681: true,
    682: true, 683: true, 684: true, 685: true, 686: true, 687: true, 688: true,
    689: true, 690: true, 691: true, 702: true, 703: true, 704: true, 705: true,
    706: true, 707: true, 708: true, 709: true, 710: true, 711: true, 712: true,
    713: true, 714: true, 715: true, 716: true, 717: true, 718: true, 719: true,
    720: true, 721: true, 722: true, 723: true, 732: true, 733: true, 734: true,
    735: true, 762: true, 763: true, 764: true, 765: true, 766: true, 767: true,
    768: true, 769: true, 770: true, 771: true, 772: true, 773: true, 774: true,
    775: true, 776: true, 777: true, 778: true, 779: true, 780: true, 781: true,
    782: true, 783: true, 784: true, 785: true, 786: true, 787: true, 793: true,
    794: true, 795: true, 796: true, 797: true, 798: true, 799: true, 824: true,
    825: true, 826: true, 827: true, 828: true, 829: true, 830: true, 831: true,
    855: true, 856: true, 857: true, 858: true, 859: true, 860: true, 861: true,
    862: true, 863: true, 864: true, 865: true, 866: true, 867: true, 868: true,
    869: true, 870: true, 871: true, 872: true, 873: true, 874: true, 875: true,
    876: true, 877: true, 878: true, 879: true, 880: true, 881: true, 882: true,
    883: true, 887: true, 888: true, 889: true, 890: true, 891: true, 892: true,
    893: true, 894: true, 895: true, 896: true, 897: true, 898: true, 899: true,
    900: true, 901: true, 902: true, 903: true, 904: true, 905: true, 906: true,
    907: true, 908: true, 909: true, 910: true, 911: true, 912: true, 913: true,
    914: true, 915: true, 918: true, 919: true, 920: true, 921: true, 922: true,
    923: true, 924: true, 925: true, 926: true, 927: true, 950: true, 951: true,
    952: true, 953: true, 954: true, 955: true, 956: true, 957: true, 958: true,
    959: true, 960: true, 961: true, 962: true, 963: true, 964: true, 965: true,
    966: true, 967: true, 968: true, 969: true, 970: true, 971: true, 972: true,
    973: true, 974: true, 975: true, 976: true, 977: true, 978: true, 979: true,
    981: true, 982: true, 983: true, 984: true, 985: true, 986: true, 987: true,
    988: true, 989: true, 990: true, 991: true, 1013: true, 1014: true,
    1015: true, 1016: true, 1017: true, 1018: true, 1019: true, 1020: true,
    1021: true, 1022: true, 1023: true,
  },
});
